// extracted by mini-css-extract-plugin
module.exports = {"holder":"_3CQV-","isPlaying":"_2JNfs","thumbnail":"_3VKKf","playerHolder":"_2Y3Yu","player":"_2W-c_"};